import { type Route } from '!/router'
import { keys } from '@/jail'
import { Footer } from '@/ui/components/Footer'
import { NoContentBlock } from '@/ui/components/NoContentBlock'
import { AccountSettingsModal } from '~/features/portal/redirect'
import { NavBar } from '~/widgets/NavBar'
import { PartnerProgramGoPopup } from '~/widgets/PartnerProgram/PartnerProgramGoPopup'
import {
  AuthorizePaymentForm,
  ExternalPaymentOpen,
  GravyPaymentForm,
  NoPaymentForm,
} from '~/widgets/Payment'
import {
  AnnouncementPopup,
  InfoPopup,
  PinLockPopup,
  ProfilesCreatePopup,
  ProfilesRemovePopup,
} from '~/widgets/Popups'
import { SignInToWatchPopup } from '~/widgets/SignInToWatch'
import * as partnerProgramDetails from './partner-program/details'
import * as partnerProgram from './partner-program/grid'
import * as root from './root'

export default {
  keys: [keys.app, keys.guest],

  children: [
    {
      // do not load old home never
      filter: () => false,

      path: '',
      component: [
        NavBar,
        root.HomePage,
        GravyPaymentForm,
        AuthorizePaymentForm,
        NoPaymentForm,
        ExternalPaymentOpen,
        PinLockPopup,
        NoContentBlock,
        Footer,
        SignInToWatchPopup,
        ProfilesRemovePopup,
        ProfilesCreatePopup,
        AnnouncementPopup,
        AccountSettingsModal,
      ],
      skin: root.skin,
      init: root.model.init,
      left: root.model.left,
    },

    // TODO: move partner-program routes to separate folder
    {
      path: '/partner-program',
      component: [
        NavBar,
        partnerProgram.PartnerProgramGridPage,
        GravyPaymentForm,
        AuthorizePaymentForm,
        NoPaymentForm,
        ExternalPaymentOpen,
        SignInToWatchPopup,
        PinLockPopup,
        NoContentBlock,
        Footer,
        ProfilesRemovePopup,
        ProfilesCreatePopup,
        AnnouncementPopup,
        AccountSettingsModal,
      ],
      skin: partnerProgram.skin,
      init: partnerProgram.model.init,
      left: partnerProgram.model.left,
    },
    {
      path: '/partner-program/:partnerProductId',
      component: [
        NavBar,
        partnerProgramDetails.PartnerProgramDetailsPage,
        GravyPaymentForm,
        AuthorizePaymentForm,
        NoPaymentForm,
        ExternalPaymentOpen,
        InfoPopup,
        SignInToWatchPopup,
        NoContentBlock,
        Footer,
        PartnerProgramGoPopup,
        ProfilesRemovePopup,
        ProfilesCreatePopup,
        AnnouncementPopup,
        AccountSettingsModal,
      ],
      skin: partnerProgramDetails.skin,
      init: partnerProgramDetails.model.init,
      left: partnerProgramDetails.model.left,
    },
  ],
} satisfies Route
